import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import css from './CalendarDownloadButton.module.css';

/**
 * CalendarDownloadButton — adds booking to Google/Apple/Outlook Calendar.
 *
 * Downloads a .ics file from /api/calendar/booking/:txId.
 * Users then open the file to import to their calendar.
 *
 * Usage (in TransactionPanel):
 *   {features.googleCalendar && booking && (
 *     <CalendarDownloadButton txId={transaction.id.uuid} />
 *   )}
 */
const CalendarDownloadButton = ({ txId, className }) => (
  <a
    href={`/api/calendar/booking/${txId}`}
    download={`booking-${txId}.ics`}
    className={classNames(css.button, className)}
  >
    <svg className={css.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
      <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
      <line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
    <FormattedMessage id="CalendarDownloadButton.label" />
  </a>
);

CalendarDownloadButton.defaultProps = { className: null };
CalendarDownloadButton.propTypes = { txId: string.isRequired, className: string };

export default CalendarDownloadButton;
